const genericUrl = process.env.REACT_APP_API_URL;

export async function GetShopItems(aulaId: string = "0") {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/shop/items/${aulaId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            return await response.json();
        } else {
            return [];
        }
    } catch (e) {
        console.error(e);
        return [];
    }
}
